// Cena odniesienia przy produkcie (ustawa o informowaniu o cenach, art. 4 ust. 2 — dyrektywa Omnibus):
// • pakiet — łączna cena produktów kupowanych osobno (porównanie, nie obniżka),
// • obniżka — wyłącznie z podaną najniższą ceną z 30 dni przed obniżką (pole lowest_price_30d),
// • w pozostałych przypadkach nie pokazujemy przekreślonej „starej” ceny.
export const isBundle = (p) => /pakiet/i.test(p?.id || "");

export function refPrice(p) {
  if (!p?.old_price || p.old_price <= p.price) return null;
  if (isBundle(p)) return { kind: "bundle", value: p.old_price, save: p.old_price - p.price };
  if (p.lowest_price_30d) return { kind: "promo", value: p.old_price, lowest: p.lowest_price_30d, pct: Math.round((1 - p.price / p.old_price) * 100) };
  return null;
}

export const zl = (v) => `${Number(v).toFixed(2)} zł`;
